import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { CONSENT_PROPERTY_API } from "./apiRoutes";

interface getProps {
  communityId: string;
  propertyId: string;
  type: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getConsentNeighbor = async (communityId: string, propertyId: string, type: string) =>
  await axiosAuth.get(`${CONSENT_PROPERTY_API(communityId, propertyId)}/neighbors/${type}`);

const useGetConsentNeighbor = ({
  communityId,
  propertyId,
  type,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["neighbors-list", communityId],
    queryFn: () => getConsentNeighbor(communityId, propertyId, type),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetConsentNeighbor;
